var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSp500Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4162E",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.029 36c3.677 0 6.218-2.14 6.218-5.39v-.022c0-2.927-2.207-5.046-5.26-5.046-1.627 0-2.953.634-3.622 1.678H10.3l.39-4.368h7.429V20H8.014l-.735 9.383h2.93c.19-.323.446-.624.77-.86.545-.42 1.247-.657 2.072-.657 1.738 0 2.975 1.151 2.986 2.787v.021c0 1.657-1.236 2.82-2.997 2.82-1.55 0-2.675-.904-2.909-2.077l-.022-.076H7l.011.162C7.211 34.096 9.53 36 13.03 36ZM27.47 36c4.08 0 6.553-3.023 6.553-7.962v-.021c0-4.94-2.474-8.017-6.552-8.017-4.079 0-6.553 3.078-6.553 8.017v.021c0 4.94 2.474 7.962 6.553 7.962Zm0-2.539c-2.005 0-3.153-2.012-3.153-5.423v-.021c0-3.412 1.148-5.413 3.154-5.413 2.006 0 3.153 2.002 3.153 5.413v.021c0 3.411-1.147 5.423-3.153 5.423ZM42.448 36C46.526 36 49 32.977 49 28.038v-.021C49 23.076 46.526 20 42.448 20c-4.079 0-6.553 3.078-6.553 8.017v.021c0 4.94 2.474 7.962 6.553 7.962Zm0-2.539c-2.006 0-3.154-2.012-3.154-5.423v-.021c0-3.412 1.148-5.413 3.154-5.413 2.005 0 3.153 2.002 3.153 5.413v.021c0 3.411-1.148 5.423-3.153 5.423Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSp500Logo);
export default __webpack_public_path__ + "static/media/sp500-logo.d577e05741f71d7b3a17cde37eceb2bc.svg";
export { ForwardRef as ReactComponent };